import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
	providedIn: 'root',
})
export class SystemAvailabilityApiService {
	constructor(private apiService: ApiService) {
		//
	}

	getSystemAvailabilityNotes(): Observable<string> {
		return this.apiService.get('/SystemAvailability/GetSystemAvailabilityNotes') as Observable<string>;
	}
}
